import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  es: {
    translation: {
      // Navigation
      "nav.dashboard": "Dashboard",
      "nav.libro": "Libro Digital",
      "nav.reservations": "Reservaciones",
      "nav.waitlist": "Lista de Espera",
      "nav.floorPlan": "Plano de Sala",
      "nav.customers": "Clientes",
      "nav.analytics": "Analíticas",
      "nav.settings": "Configuración",
      "nav.widget": "Widget",
      "nav.marketing": "Marketing",
      "nav.detection": "Alertas",
      "nav.events": "Eventos",
      "nav.risk": "No-Shows",
      "nav.experiences": "Experiencias",
      "nav.integrations": "Integraciones",
      
      // Auth
      "auth.login": "Iniciar Sesión",
      "auth.register": "Registrarse",
      "auth.logout": "Cerrar Sesión",
      "auth.email": "Correo electrónico",
      "auth.password": "Contraseña",
      "auth.name": "Nombre",
      "auth.restaurantName": "Nombre del Restaurante",
      "auth.welcome": "Bienvenido a RestoOS",
      "auth.subtitle": "Sistema de reservaciones profesional",
      "auth.noAccount": "¿No tienes cuenta?",
      "auth.hasAccount": "¿Ya tienes cuenta?",
      
      // Dashboard
      "dashboard.title": "Dashboard",
      "dashboard.todayReservations": "Reservaciones Hoy",
      "dashboard.totalCovers": "Comensales Hoy",
      "dashboard.occupancy": "Ocupación",
      "dashboard.noShows": "No-Shows",
      "dashboard.upcomingReservations": "Próximas Reservaciones",
      "dashboard.recentActivity": "Actividad Reciente",
      
      // Reservations
      "reservations.title": "Reservaciones",
      "reservations.new": "Nueva Reservación",
      "reservations.edit": "Editar Reservación",
      "reservations.guestName": "Nombre del Huésped",
      "reservations.phone": "Teléfono",
      "reservations.email": "Email",
      "reservations.date": "Fecha",
      "reservations.time": "Hora",
      "reservations.partySize": "Personas",
      "reservations.duration": "Duración (min)",
      "reservations.table": "Mesa",
      "reservations.status": "Estado",
      "reservations.notes": "Notas",
      "reservations.specialRequests": "Peticiones Especiales",
      "reservations.source": "Origen",
      "reservations.noReservations": "No hay reservaciones",
      
      // Status
      "status.available": "Disponible",
      "status.reserved": "Reservada",
      "status.seated": "Ocupada",
      "status.finished": "Terminada",
      "status.blocked": "Bloqueada",
      "status.pending": "Pendiente",
      "status.confirmed": "Confirmada",
      "status.cancelled": "Cancelada",
      "status.no_show": "No-Show",
      "status.completed": "Completada",
      
      // Floor Plan
      "floorPlan.title": "Plano de Sala",
      "floorPlan.addTable": "Agregar Mesa",
      "floorPlan.addZone": "Agregar Zona",
      "floorPlan.editTable": "Editar Mesa",
      "floorPlan.tableNumber": "Número de Mesa",
      "floorPlan.capacity": "Capacidad",
      "floorPlan.shape": "Forma",
      "floorPlan.round": "Redonda",
      "floorPlan.square": "Cuadrada",
      "floorPlan.rectangle": "Rectangular",
      
      // Customers
      "customers.title": "Clientes",
      "customers.new": "Nuevo Cliente",
      "customers.edit": "Editar Cliente",
      "customers.search": "Buscar clientes...",
      "customers.totalVisits": "Visitas",
      "customers.noShowCount": "No-Shows",
      "customers.preferences": "Preferencias",
      "customers.tags": "Etiquetas",
      "customers.history": "Historial",
      
      // Analytics
      "analytics.title": "Analíticas",
      "analytics.overview": "Resumen",
      "analytics.reservationsByDay": "Reservaciones por Día",
      "analytics.occupancyRate": "Tasa de Ocupación",
      "analytics.noShowRate": "Tasa de No-Show",
      "analytics.avgPartySize": "Promedio de Personas",
      
      // Settings
      "settings.title": "Configuración",
      "settings.general": "General",
      "settings.timeSlots": "Turnos",
      "settings.policies": "Políticas",
      "settings.team": "Equipo",
      
      // Widget
      "widget.title": "Configurador de Widget",
      "widget.preview": "Vista Previa",
      "widget.embedCode": "Código para Embeber",
      "widget.copy": "Copiar Código",
      
      // Common
      "common.save": "Guardar",
      "common.cancel": "Cancelar",
      "common.delete": "Eliminar",
      "common.edit": "Editar",
      "common.create": "Crear",
      "common.search": "Buscar",
      "common.filter": "Filtrar",
      "common.loading": "Cargando...",
      "common.error": "Error",
      "common.success": "Éxito",
      "common.today": "Hoy",
      "common.tomorrow": "Mañana",
      "common.week": "Semana",
      "common.month": "Mes",
      "common.all": "Todos",
      "common.none": "Ninguno",
      "common.close": "Cerrar",
      "common.confirm": "Confirmar",
      "common.actions": "Acciones",
      "common.details": "Detalles",
      "common.people": "personas",
    }
  },
  en: {
    translation: {
      // Navigation
      "nav.dashboard": "Dashboard",
      "nav.libro": "Digital Book",
      "nav.reservations": "Reservations",
      "nav.waitlist": "Waitlist",
      "nav.floorPlan": "Floor Plan",
      "nav.customers": "Customers",
      "nav.analytics": "Analytics",
      "nav.settings": "Settings",
      "nav.widget": "Widget",
      "nav.marketing": "Marketing",
      "nav.detection": "Alerts",
      "nav.events": "Events",
      "auth.register": "Register",
      "auth.logout": "Logout",
      "auth.email": "Email",
      "auth.password": "Password",
      "auth.name": "Name",
      "auth.restaurantName": "Restaurant Name",
      "auth.welcome": "Welcome to RestoOS",
      "auth.subtitle": "Professional reservation system",
      "auth.noAccount": "Don't have an account?",
      "auth.hasAccount": "Already have an account?",
      
      // Dashboard
      "dashboard.title": "Dashboard",
      "dashboard.todayReservations": "Today's Reservations",
      "dashboard.totalCovers": "Total Covers",
      "dashboard.occupancy": "Occupancy",
      "dashboard.noShows": "No-Shows",
      "dashboard.upcomingReservations": "Upcoming Reservations",
      "dashboard.recentActivity": "Recent Activity",
      
      // Reservations
      "reservations.title": "Reservations",
      "reservations.new": "New Reservation",
      "reservations.edit": "Edit Reservation",
      "reservations.guestName": "Guest Name",
      "reservations.phone": "Phone",
      "reservations.email": "Email",
      "reservations.date": "Date",
      "reservations.time": "Time",
      "reservations.partySize": "Party Size",
      "reservations.duration": "Duration (min)",
      "reservations.table": "Table",
      "reservations.status": "Status",
      "reservations.notes": "Notes",
      "reservations.specialRequests": "Special Requests",
      "reservations.source": "Source",
      "reservations.noReservations": "No reservations",
      
      // Status
      "status.available": "Available",
      "status.reserved": "Reserved",
      "status.seated": "Seated",
      "status.finished": "Finished",
      "status.blocked": "Blocked",
      "status.pending": "Pending",
      "status.confirmed": "Confirmed",
      "status.cancelled": "Cancelled",
      "status.no_show": "No-Show",
      "status.completed": "Completed",
      
      // Floor Plan
      "floorPlan.title": "Floor Plan",
      "floorPlan.addTable": "Add Table",
      "floorPlan.addZone": "Add Zone",
      "floorPlan.editTable": "Edit Table",
      "floorPlan.tableNumber": "Table Number",
      "floorPlan.capacity": "Capacity",
      "floorPlan.shape": "Shape",
      "floorPlan.round": "Round",
      "floorPlan.square": "Square",
      "floorPlan.rectangle": "Rectangle",
      
      // Customers
      "customers.title": "Customers",
      "customers.new": "New Customer",
      "customers.edit": "Edit Customer",
      "customers.search": "Search customers...",
      "customers.totalVisits": "Visits",
      "customers.noShowCount": "No-Shows",
      "customers.preferences": "Preferences",
      "customers.tags": "Tags",
      "customers.history": "History",
      
      // Analytics
      "analytics.title": "Analytics",
      "analytics.overview": "Overview",
      "analytics.reservationsByDay": "Reservations by Day",
      "analytics.occupancyRate": "Occupancy Rate",
      "analytics.noShowRate": "No-Show Rate",
      "analytics.avgPartySize": "Avg Party Size",
      
      // Settings
      "settings.title": "Settings",
      "settings.general": "General",
      "settings.timeSlots": "Time Slots",
      "settings.policies": "Policies",
      "settings.team": "Team",
      
      // Widget
      "widget.title": "Widget Builder",
      "widget.preview": "Preview",
      "widget.embedCode": "Embed Code",
      "widget.copy": "Copy Code",
      
      // Common
      "common.save": "Save",
      "common.cancel": "Cancel",
      "common.delete": "Delete",
      "common.edit": "Edit",
      "common.create": "Create",
      "common.search": "Search",
      "common.filter": "Filter",
      "common.loading": "Loading...",
      "common.error": "Error",
      "common.success": "Success",
      "common.today": "Today",
      "common.tomorrow": "Tomorrow",
      "common.week": "Week",
      "common.month": "Month",
      "common.all": "All",
      "common.none": "None",
      "common.close": "Close",
      "common.confirm": "Confirm",
      "common.actions": "Actions",
      "common.details": "Details",
      "common.people": "people",
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'es',
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
